<template>
  <div
    class="divider relative transition-all"
    :class="{
      '!min-h-px': rotation === 'horizontal',
      '!max-w-px !min-w-px': rotation === 'vertical',
      'my-1': spacing && rotation === 'horizontal',
      'mx-2': spacing && rotation === 'vertical',
      'bg-bdr-primary': strong,
      'bg-bdr-subtle': !strong,
    }"
  >
    <div
      v-if="text"
      class="bg-bgr-primary text-body-small absolute -top-[11px] left-1/2 flex h-[20px] -translate-x-1/2 items-center rounded-full border px-2 leading-0"
      :class="{ 'border-bdr-primary': strong, 'border-bdr-subtle': !strong }"
    >
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      rotation?: "vertical" | "horizontal";
      spacing?: boolean;
      text?: string | null;
      strong?: boolean;
    }>(),
    {
      rotation: "horizontal",
      spacing: true,
      text: "",
      strong: false,
    }
  );
</script>
